<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: main page
  Author: SDL
  Brief: Page to enter after login
-->
<template>
  <!-- SUB Contents -->
  <div class="ui--content-wrapper display_b"  v-if="isLoaderVisible">
    <!--Contents Area -->
    <!-- jumbotron -->
    <div class="jumbotron index-img" >
      <div class="container inner">
        <div class="row">
          <div class="col-5">
            <h1>ABC</h1>
            <strong>ABC System Summary</strong>
            <p>The ABC provides a comprehensive programming, configuration model and reuseable common module for modern Java-based enterprise applications. <a href="#;">Learn more</a></p>
            <form class="form-inline search-group mt-5">
              <input class="form-control" type="text" placeholder="Input the keyword" aria-label="Input the keyword">
              <button class="btn btn-search" type="submit">Search</button>
            </form>
          </div>
          <div class="col-7"><img :src="$CONTEXT + '/static/image/main/main_object1.png'" alt="main object" class="main-object" ></div>
        </div>
      </div>
    </div>
    <!-- //jumbotron -->

    <!-- row1 -->
    <div class="mcontents mcontents-1">
      <!-- contents in -->
      <div class="section-heading text-center">
        <h4>Our Quick <span class="uppercase">Menu</span>s</h4>
        <p>{{ $t('sdl.main.message.quickMenuMsg') }}.</p>
      </div>
      <div class="row container">
        <div class="col-3 text-center">
          <a class="link-icon" href="#">
            <div class="circle-icon circle-2 circle-color-1"><em class="icon-screen-desktop"></em></div>
            <div class="link-text">링크1</div>
          </a>
        </div>
        <div class="col-3 text-center">
          <a class="link-icon" href="#">
            <div class="circle-icon circle-2 circle-color-1"><em class="icon-screen-smartphone"></em></div>
            <div class="link-text">링크2</div>
          </a>
        </div>
        <div class="col-3 text-center">
          <a class="link-icon" href="#">
            <div class="circle-icon circle-2 circle-color-1"><em class="icon-book-open"></em></div>
            <div class="link-text">링크3</div>
          </a>
        </div>
        <div class="col-3 text-center">
          <a class="link-icon" href="#">
            <div class="circle-icon circle-2 circle-color-1"><em class="icon-picture"></em></div>
            <div class="link-text">링크4</div>
          </a>
        </div>
      </div>
      <!-- // contents in -->
    </div>

    <!-- row2 -->
    <div class="mcontents mcontents-2">
      <!-- contents in -->
      <div class="section-heading text-center">
        <h4>Popular Help <span class="uppercase">Topic</span>s</h4>
        <p>{{ $t('sdl.main.message.findTopic') }}</p>
      </div>
      <div class="row container mt-5">
        <div class="col-4">
          <div class="topic-box">
            <div class="circle-icon circle-2 circle-color-2"><em class="icon-note"></em></div>
            <h5>신규사용 신청</h5>
            <p>개발과제 추진정보, 공통기능 사용현황을 작성 Knox Portal 메모결재를 진행합니다.</p>
            <a href="#;">자세히보기</a>
          </div>
        </div>
        <div class="col-4">
          <div class="topic-box">
            <div class="circle-icon circle-2 circle-color-2"><em class="icon-bubbles"></em></div>
            <h5>기술지원 요청</h5>
            <p>개발과제명, 문의사항을 작성 후, 담당자에게 메일로 요청합니다.</p>
            <a href="#;">자세히보기</a>
          </div>
        </div>
        <div class="col-4">
          <div class="topic-box">
            <div class="circle-icon circle-2 circle-color-2"><em class="icon-people"></em></div>
            <h5>개발교육 실행</h5>
            <p>교육은 매월 1회 실시되며, 참석자 명단을 작성하여 메일로 사전요청 합니다.</p>
            <a href="#;">자세히보기</a>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <p class="col-12 text-center mb-3">찾고 있는 것이 없습니까? 더 많은 TOPIC을 만나보세요.</p>
        <p class="col-12 text-center"><button class="btn btn-topic-more">더 많은 TOPIC 찾아보기</button></p>
      </div>
      <!-- // contents in -->
    </div>

    <!-- row3 -->
    <div class="mcontents mcontents-3">
      <!-- contents in -->
      <div class="row">
        <div class="col-5 board-box">
          <header class="group-header">
            <h4>{{ $t('sdl.main.message.notice') }}</h4>
            <small
              ><router-link :to="$CONTEXT + '/board/notice/user/list'">{{
                $t('sdl.main.message.viewMore')
              }}</router-link></small
            >
          </header>
          <!-- notice list -->
          <ul class="list-group list-border">
            <li
              class="list-group-item"
              v-for="row in noticeList"
              :key="row.postId"
              @click.prevent="$router.push(`${$context}/board/notice/user/view/${row.postId}/default`)"
            >
              <a href="#">{{ row.postTitle }}</a>
              <small class="float-right">{{ row.regDate | dateFormat }}</small>
            </li>
          </ul>
        </div>
        <div class="col-5 board-box">
          <header class="group-header">
            <h4>FAQ</h4>
            <small
              ><router-link :to="$CONTEXT + '/board/faq/user/list'">{{
                $t('sdl.main.message.viewMore')
              }}</router-link></small
            >
          </header>
          <!-- faq list -->
          <ul class="list-group list-border">
            <li
              class="list-group-item"
              v-for="row in faqList"
              :key="row.postId"
              @click.prevent="$router.push(`${$context}/board/faq/user/view/${row.postId}/default`)"
            >
              <a href="#">{{ row.postTitle }}</a>
              <small class="float-right">{{ row.regDate | dateFormat }}</small>
            </li>
          </ul>
        </div>
        <div class="col-2 help-box">
          <header class="group-header">
            <h4>Help</h4>
          </header>
          <ul>
            <li>
              <a href="javascript:">{{ $t('sdl.common.projectHelp') }}</a>
              <p class="text-tell">1688-0987</p>
            </li>
            <li class="itvoc">
              <a href="#;"><img :src="$CONTEXT + '/static/image/main/logo_itvoc.png'" alt="IT VOC Link"/></a>
            </li>
          </ul>
        </div>
      </div>
      <!-- // contents in -->
    </div>

    <!--//Contents Area -->
  </div>
</template>

<script>
import axios from 'axios';
import { SDLUtil, StringUtil } from '@/utils';

export default {
  name: 'MainIndexPage',
  data() {
    return {
      noticeList: [],
      faqList: [],
      isLoaderVisible: false,
    };
  },
  methods: {
    // 리스트 조회
    getBoardList(boardId) {
      // 게시판 설정 정보에 따라 parameter 구성
      const params = {
        pageIndex: 1,
        boardId,
        pageSize: 4,
        // classificationId: this.boardInfo.searchClassificationUsed ? this.classificationId : null,
      };

      // Loading bar execution
      SDLUtil.showLoadingBar(true);
      axios
        .get(`${SDLUtil.API_URL}/boards/${boardId}/posts-with-paging?${StringUtil.queryStringfy(params)}`)
        .then(({ data }) => {
          // console.log(data);
          // if (_.eq(this.boardInfo.boardType, 'BASIC')) this.convertBasicList(data.rows);
          // else this.convertPictureList(data.rows);
          // this.currentPage = data.currentPage;
          // this.records = data.records;
          // Loading bar hidden
          if (boardId === 'notice') {
            this.noticeList = data.rows;
          } else {
            this.faqList = data.rows;
          }

          SDLUtil.showLoadingBar(false);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
        });
    },
  },
  created() {
    this.getBoardList('notice');
    this.getBoardList('faq');
  },
};
</script>
<style scoped>
.ui--section-container .ui--content-wrapper{display: block !important;}
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainIndexPage.vue